import { useState } from 'react';
import { CheckCircle2, AlertTriangle, ChevronDown, ChevronUp, Copy, ExternalLink, Play, Eye, MonitorUp } from 'lucide-react';
import { toast } from 'sonner';
import { ASSET_CHECKLIST } from './assets';
import { PRESENTATION, SCENES, TOTAL_SECONDS, PRESENTATION_BASE } from './presentationConfig';
import './AssetChecklist.css';

// Super-admin only card shown in Admin → Presentations. Never rendered on the public URL.
export default function JacksonStopsCard() {
  const [open, setOpen] = useState(false);
  const base = `${window.location.origin}${PRESENTATION_BASE}`;
  const missing = ASSET_CHECKLIST.filter((a) => a.status !== 'available').length;
  const copy = async (text, label) => {
    try { await navigator.clipboard.writeText(text); toast.success(`${label} copied`); } catch { toast.error('Copy failed'); }
  };
  const mins = Math.floor(TOTAL_SECONDS / 60); const secs = String(TOTAL_SECONDS % 60).padStart(2, '0');
  return (
    <div className="jsp-card" data-testid="jsp-featured-card">
      <div className="jsp-glow" />
      <div className="jsp-head">
        <div>
          <div className="jsp-eyebrow">Featured · PechaKucha 20 × 20</div>
          <h2 className="jsp-title">{PRESENTATION.title}</h2>
          <p className="jsp-sub">{SCENES.length} cinematic scenes · {mins}:{secs} · {PRESENTATION.subtitle}</p>
        </div>
        <div className="jsp-actions">
          <a className="jsp-btn" href={`${PRESENTATION_BASE}?key=${PRESENTATION.passcode}`} target="_blank" rel="noreferrer" data-testid="jsp-preview-btn"><Eye size={16} /> Preview</a>
          <a className="jsp-btn jsp-btn-primary" href={`${PRESENTATION_BASE}/present?autoplay=true&key=${PRESENTATION.passcode}`} target="_blank" rel="noreferrer" data-testid="jsp-present-btn"><Play size={16} /> Present</a>
          <a className="jsp-btn" href={`${PRESENTATION_BASE}/presenter?key=${PRESENTATION.passcode}`} target="_blank" rel="noreferrer" data-testid="jsp-presenter-btn"><MonitorUp size={16} /> Presenter view</a>
          <button className="jsp-btn" onClick={() => copy(base, 'Share link')} data-testid="jsp-copy-link-btn"><Copy size={16} /> Copy share link</button>
        </div>
      </div>
      <div className="jsp-share">
        <span className="jsp-share-k">Share</span>
        <code>{base}</code>
        <span className="jsp-share-k">Passcode</span>
        <code data-testid="jsp-passcode">{PRESENTATION.passcode}</code>
        <button className="jsp-link" onClick={() => copy(PRESENTATION.passcode, 'Passcode')}><Copy size={13} /></button>
      </div>
      <button className="jsp-toggle" onClick={() => setOpen((v) => !v)} data-testid="jsp-checklist-toggle">
        {missing > 0 ? <AlertTriangle size={16} className="jsp-amber" /> : <CheckCircle2 size={16} className="jsp-lime" />}
        Asset checklist · {ASSET_CHECKLIST.length - missing} ready · {missing} need replacing
        {open ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
      </button>
      {open && (
        <div className="jsp-checklist" data-testid="jsp-checklist">
          {ASSET_CHECKLIST.map((a) => (
            <div key={a.label} className={`jsp-row ${a.status}`}>
              {a.status === 'available' ? <CheckCircle2 size={18} className="jsp-lime" /> : <AlertTriangle size={18} className="jsp-amber" />}
              <div className="jsp-row-body">
                <div className="jsp-row-label">{a.label}</div>
                {a.note && <div className="jsp-row-note">{a.note}</div>}
              </div>
              {(a.url || a.source) && <a className="jsp-link" href={a.url || a.source} target="_blank" rel="noreferrer"><ExternalLink size={14} /></a>}
              <span className="jsp-status">{a.status === 'available' ? 'Available' : 'Replacement required'}</span>
            </div>
          ))}
          <div className="jsp-foot">Edit copy, stats and media in <code>src/presentation/presentationConfig.js</code> · assets in <code>src/presentation/assets.js</code></div>
        </div>
      )}
    </div>
  );
}
